module.exports = __webpack_public_path__ + "img/norway-leukaemia-male.e3b42223.png";